<template>
    <div id="login_v2" class="font-source-sans">
        <div class="login_title mb-5">
            <p>
                Pour visualiser les prix, <br />
                connectez-vous ou <br />
                créez un compte
            </p>
        </div>

        <div class="login_auth">
            <p class="font-bold">E-mail</p>
            <div class="input_wrapper relative w-full mt-2 mb-5">
                <input class="input_mail" type="text" placeholder="Votre e-mail" v-model="form_login.email" />
                <div class="email_img_wrapper">
                    <img src="img/auth/mail.svg" alt="" />
                </div>
            </div>

            <p class="font-bold">Mot de passe</p>
            <div class="input_wrapper relative w-full mt-2 mb-6">
                <input ref="password" class="input_password" type="password" placeholder="Votre mot de passe" v-model="form_login.password" />
                <div class="key_img_wrapper">
                    <img src="img/auth/key.svg" alt="" />
                </div>
                <div class="eye_img_wrapper cursor-pointer" @click="switchPasswordVisibility">
                    <svg ref="eye" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.5" height="11.25" viewBox="0 0 16.5 11.25">
                        <defs>
                            <clipPath id="clip-path">
                                <path
                                    id="Eye"
                                    d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                    transform="translate(0.75 0.375)"
                                    fill="#dfe2e6"
                                />
                            </clipPath>
                        </defs>
                        <g id="Suche" transform="translate(-0.75 -0.375)">
                            <path
                                id="Eye-2"
                                data-name="Eye"
                                d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                transform="translate(0.75 0.375)"
                                :fill="isPasswordVisible ? '#4e4e4e' : '#dfe2e6'"
                            />
                        </g>
                    </svg>
                </div>
            </div>

            <div class="buttons-wrapper flex justify-between mb-5">
                <button type="button" class="btn sign-up-btn" @click="openSignupV2">Créer un compte</button>
                <button type="button" class="btn login-btn" @click="loginLoginFromForm">Se connecter</button>
            </div>

            <div class="flex justify-between">
                <div class="terms">
                    <label class="terms_label"
                        >Se souvenir de moi
                        <input ref="checkbox" type="checkbox" v-model="rememberPassword" @click.self="rememberPasswordHandler" />
                        <span class="checkmark"></span>
                    </label>
                </div>

                <div class="reset-password" @click="openConfirmMailV2">Mot de passe oublié</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Autentification from '@/services/Autentification';

    export default {
        name: 'LoginV2',
        data() {
            return {
                isPasswordVisible: false,
                rememberPassword: false,

                form_login: {
                    email: '',
                    password: ''
                }
            };
        },
        mounted() {
            let api_token = window.localStorage.getItem('api_token');
            this.$store.commit('setApiToken', api_token);
        },
        methods: {
            clearLogin() {
                var self = this;
                self.form_login.email = '';
                self.form_login.password = '';
            },

            toggleAuthModal() {
                this.clearLogin();
                $eventbus.$emit('toggle:modal');
            },

            openSignupV2() {
                $eventbus.$emit('open:signup-v2');
            },

            openConfirmMailV2() {
                $eventbus.$emit('open:confirm-mail-v2');
            },

            openResetPasswordV2() {
                $eventbus.$emit('open:reset-password-v2');
            },

            isValidEmail(email) {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email) ? true : false;
            },

            switchPasswordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible;
                if (this.$refs.password.getAttribute('type') === 'password') this.$refs.password.setAttribute('type', 'text');
                else this.$refs.password.setAttribute('type', 'password');
            },

            rememberPasswordHandler() {
                if (this.$refs.checkbox.checked) {
                    this.rememberPassword = true;
                } else {
                    this.rememberPassword = false;
                }
                console.log('REMEMBER PASS VARIABLE: ' + this.rememberPassword);
            },

            loginLoginFromForm() {
                var self = this;
                // preia datele
                self.form_login.email = self.form_login.email.trim().toLowerCase();
                self.form_login.password = self.form_login.password.trim();
                //
                window.localStorage.removeItem('api_token');
                // valideaza datele
                if (self.form_login.email.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else if (!self.isValidEmail(self.form_login.email)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else if (self.form_login.password.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une mod de passe valide.');
                } else {
                    Autentification.login({
                        kta_id: '',
                        email: self.form_login.email,
                        password: self.form_login.password
                    })
                        .then((result) => {
                            var data = result.data;

                            if (data && data.error) {
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {
                                let api_token = data.data.api_token;


                                window.localStorage.setItem('api_token', api_token);

                                self.$store.commit('setApiToken', api_token);
                                self.$store.commit('setPersistLogin', self.rememberPassword);
                                self.$store.commit('setFirstCall', false);

                                $eventbus.$emit('toggle:modal');


                                let sto = setTimeout(function(){
                                    clearTimeout(sto);

                                    if(window.parent && window.parent.MainFrame){
                                        let MainFrame = window.parent.MainFrame;
                                        let mailSentTrigger = 'mailSentFromForm';

                                        MainFrame.Manager.Variables.register("loggedOut", "0");
                                        MainFrame.Manager.Variables.register("api_token", api_token);
                                        MainFrame.EprintShop.saveItem("api_token", api_token);

                                        // MainFrame.EventHandler.dispatch(mailSentTrigger);
                                        // MainFrame.EventHandler.dispatch('mailSentFromForm');
                                        MainFrame.EventHandler.dispatch('closeLogin');
                                        MainFrame.EventHandler.dispatch('loginSuccess');
                                        MainFrame.EventHandler.dispatch("userIsLoggedIn");
                                    }
                                },1000);

                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(() => {
                            self.clearLogin();
                        });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    #login_v2 {
        width: 100%;
        max-width: 350px;
        padding: 1rem 0;
        .login_title {
            font-size: 22px;
            font-weight: bold;
        }
        .login_auth {
            * {
                user-select: none;
            }
            p {
                font-size: 13px;
                color: #6b6c6f;
            }
            .input_wrapper {
                position: relative;
                input {
                    width: 100%;
                    border: 1px solid #dfe2e6;
                    border-radius: 25px;
                    padding-block: 0.3rem;
                    padding-inline: 3rem;
                    outline: none;
                    font-size: 13px;
                    color: #6b6c6f;
                    &::placeholder {
                        font-weight: bold;
                        opacity: 0.5;
                        font-size: 16px;
                    }
                    &:focus {
                        border-color: #6b6c6f;
                    }
                }
                .email_img_wrapper {
                    position: absolute;
                    top: 50%;
                    left: 25px;
                    translate: -50% -50%;
                    width: 20px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
                .key_img_wrapper {
                    position: absolute;
                    top: 50%;
                    left: 25px;
                    translate: -50% -50%;
                    width: 20px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
                .eye_img_wrapper {
                    position: absolute;
                    top: 50%;
                    right: 0.2rem;
                    translate: -50% -50%;
                    width: 16.5px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
            }
            .buttons-wrapper {
                .btn {
                    font-size: 14px;
                    outline: none;
                    border: none;
                    width: 100%;
                    max-width: 160px;
                    height: 40px;
                    border-radius: 2rem;
                    font-weight: 500;
                    user-select: none;
                    &.sign-up-btn {
                        border: 2px solid #4e4e4e;
                        color: #4e4e4e;
                    }
                    &.login-btn {
                        color: white;
                        background-color: #4e4e4e;
                    }
                }
            }
            .terms {
                font-size: 12px;
                color: #6b6c6f;
                font-weight: bold;
                .terms_label {
                    display: block;
                    position: relative;
                    cursor: pointer;
                    user-select: none;
                    padding-left: 26px;
                    &:hover {
                        input {
                            ~ {
                                .checkmark {
                                    background-color: rgba(223, 226, 230, 0.2);
                                    border-color: #4e4e4e;
                                }
                            }
                        }
                    }
                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        width: 0;
                        height: 0;
                        &:checked {
                            ~ {
                                .checkmark {
                                    background-color: #01a0c6;
                                    border: none;
                                    &:after {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                    .checkmark {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 18px;
                        width: 18px;
                        border: 2px solid #dfe2e6;
                        border-radius: 3px;
                        transition: 0.5s;
                        &::after {
                            content: '';
                            position: absolute;
                            display: none;
                            left: 7px;
                            top: 3px;
                            width: 5px;
                            height: 10px;
                            border: solid white;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                        }
                    }
                }
            }
            .reset-password {
                font-size: 12px;
                color: #6b6c6f;
                font-weight: bold;
                cursor: pointer;
                user-select: none;
            }
        }
    }
</style>
